import {
  EMPLOYEELOCATION_LOADING,
  GET_EMPLOYEELOCATION,
  GET_EMPLOYEELOCATION_SUCCESS,
  GET_EMPLOYEELOCATION_FAIL,
  ADD_EMPLOYEELOCATION_SUCCESS,
  ADD_EMPLOYEELOCATION_FAIL,
  DELETE_EMPLOYEELOCATION_SUCCESS,
  DELETE_EMPLOYEELOCATION_FAIL,
  UPDATE_EMPLOYEELOCATION_SUCCESS,
  UPDATE_EMPLOYEELOCATION_FAIL,
  EMPLOYEELOCATION_RESET
} from "./actionType";

const INIT_STATE = {
  employeeLocations: [],
  error: {},
};

const EmployeeLocation = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_EMPLOYEELOCATION_SUCCESS:
      switch (action.payload.actionType) {
        case GET_EMPLOYEELOCATION:
          return {
            ...state,
            employeeLocations: action.payload.data,
            isEmployeeLocationCreated: false,
            isEmployeeLocationSuccess: true,
            loading: false,
          };

        default:
          return { ...state };
      }
    case GET_EMPLOYEELOCATION_FAIL:
      switch (action.payload.actionType) {
        case GET_EMPLOYEELOCATION_FAIL:
          return {
            ...state,
            error: action.payload.error,
            isEmployeeLocationCreated: false,
            isEmployeeLocationSuccess: false,
            loading: false,
          };
        default:
          return { ...state };
      }

    case GET_EMPLOYEELOCATION: {
      return {
        ...state,
        isEmployeeLocationCreated: false,
        loading: true,
      };
    }

    case EMPLOYEELOCATION_LOADING: {
      return {
        ...state,
        isEmployeeLocationCreated: false,
        loading: true,
      };
    }

    case ADD_EMPLOYEELOCATION_SUCCESS:
      return {
        ...state,
        isEmployeeLocationCreated: true,
        loading: false,
        employeeLocations: [action.payload.data, ...state.employeeLocations],
      };

    case ADD_EMPLOYEELOCATION_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_EMPLOYEELOCATION_SUCCESS:
      return {
        ...state,
        loading: false,
        employeeLocations: state.employeeLocations.filter(
          employeeLocation => employeeLocation.id.toString() !== action.payload.id.toString()
        ),
      };

    case DELETE_EMPLOYEELOCATION_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_EMPLOYEELOCATION_SUCCESS:
      return {
        ...state,
        loading: false,
        employeeLocations: state.employeeLocations.map(employeeLocation =>
          employeeLocation.id.toString() === action.payload.data.id.toString() ? { ...employeeLocation, ...action.payload.data } : employeeLocation
        ),
      };

    case UPDATE_EMPLOYEELOCATION_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case EMPLOYEELOCATION_RESET:
      return INIT_STATE;

    default:
      return { ...state };
  }
};

export default EmployeeLocation;